"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _ApiError = _interopRequireDefault(require("./ApiError"));

var _Debug = _interopRequireDefault(require("../util/Debug"));

var _Env = require("../util/Env");

var qa = (0, _Env.isQa)() ? 'qa' : '';
var HUBLYTICS_URL = "//api.hubspot" + qa + ".com/usage-logging/v1/log/hublytics-multi/no-auth";

var HublyticsApi =
/*#__PURE__*/
function () {
  function HublyticsApi() {
    (0, _classCallCheck2.default)(this, HublyticsApi);
  }

  (0, _createClass2.default)(HublyticsApi, [{
    key: "postEvent",
    value: function postEvent(event, clientSendTimestamp) {
      var httpRequest = new XMLHttpRequest();

      if (!httpRequest) {
        throw "Could not create XMLHttpRequest. Browser may not support AJAX.";
      }

      var requestHandler = function requestHandler() {
        if (httpRequest.readyState === XMLHttpRequest.DONE) {
          if (httpRequest.status === 200) {
            (0, _Debug.default)('Logged hublytics event', event.what_event);
          } else {
            console.error('Failed to post to hublytics Api', new _ApiError.default(httpRequest));
          }
        }
      };

      httpRequest.onreadystatechange = requestHandler;
      httpRequest.open('POST', HUBLYTICS_URL + "?clientSendTimestamp=" + clientSendTimestamp);
      httpRequest.setRequestHeader('Accept', 'application/json, text/javascript');
      httpRequest.setRequestHeader('Content-type', 'application/json');
      httpRequest.send(JSON.stringify([event]));
      return true;
    }
  }]);
  return HublyticsApi;
}();

var _default = new HublyticsApi();

exports.default = _default;
module.exports = exports.default;